<template>
    <vx-card title="Shelf Life">
      <vs-tabs v-model="$route.params.tab_order">
        <vs-tab label="Fulfillment">
          <FulfillmentGroup/>
        </vs-tab>
        <vs-tab label="Interwarehouse">
          <InterWarehouseGroup/>
        </vs-tab>
        <vs-tab label="GR & GIR">
          <Inbound/>
        </vs-tab>
        <vs-tab label="Export">
          <Export/>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </template>
  <script>
  import FulfillmentGroup from "./fulfillment-group.vue";
  import InterWarehouseGroup from "./interwarehouse-group.vue";
  import Inbound from "./inbound/index.vue"
  import Export from "./export.vue"

  export default {
    components: {
      FulfillmentGroup,
      InterWarehouseGroup,
      Inbound,
      Export,
    },
    data() {
      return {
      };
    },
  };
  </script>
